module.exports = __webpack_public_path__ + "static/media/harinaintegral_harinadetrigo.46634497.png";